import { Grid, Typography } from "@material-ui/core";

import { Fragment } from "react";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocSubtitulo from "../../../utils/MeditocSubtitulo";
import { useReporteDoctor } from "../../../../context/ReporteDoctorContext";

export default function DetalleConsulta() {
    const { entConsulta, historialClinico, modalOpenDetalleConsulta, handleOpenDetalleConsulta } = useReporteDoctor();

    return (
        <MeditocModal
            level={2}
            hidecancel
            size="normal"
            okmessage="Cerrar detalle"
            title="Detalle de consulta"
            open={modalOpenDetalleConsulta}
            setopen={handleOpenDetalleConsulta}
        >
            {entConsulta && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Consulta" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="ID de consulta:" value={entConsulta.iIdConsulta} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Estatus:" value={entConsulta.sEstatusConsulta} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField
                            label="Fecha programada de inicio:"
                            value={entConsulta.sFechaProgramadaInicio}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Fecha programada de fin:" value={entConsulta.sFechaProgramadaFin} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Inicio de consulta:" value={entConsulta.sFechaConsultaInicio} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Fin de consulta:" value={entConsulta.sFechaConsultaFin} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Historia clínica" />
                    </Grid>
                    {historialClinico ? (
                        <Fragment>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Peso:" value={historialClinico.fPeso} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Altura:" value={historialClinico.fAltura} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Alergias:" value={historialClinico.sAlergias} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Síntomas:" value={historialClinico.sSintomas} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Diagnóstico:" value={historialClinico.sDiagnostico} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Tratamiento:" value={historialClinico.sTratamiento} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField
                                    label="Observaciones y comentarios:"
                                    value={historialClinico.sComentarios}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField
                                    label="Inicio de consulta:"
                                    value={historialClinico.sFechaConsultaInicio}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField label="Fin de consulta:" value={historialClinico.sFechaConsultaFin} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <MeditocInfoField
                                    label="Duración de consulta:"
                                    value={historialClinico.sDuracionConsulta}
                                />
                            </Grid>
                        </Fragment>
                    ) : (
                        <Grid item xs={12}>
                            <Typography>No se ha finalizado la consulta del paciente</Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Paciente" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Nombre:" value={entConsulta.sNombrePaciente} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Sexo:" value={entConsulta.sSexoPaciente} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Tipo de sangre:" value={entConsulta.sTipoSangrePaciente} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Fecha de nacimiento:" value={entConsulta.sFechaNacimientoPaciente} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Telefono:" value={entConsulta.sTelefonoPaciente} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Correo electrónico:" value={entConsulta.sCorreoPaciente} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Folio" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="ID de folio:" value={entConsulta.iIdFolio} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Folio:" value={entConsulta.sFolio} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Origen:" value={entConsulta.sOrigen} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Fecha de vencimiento:" value={entConsulta.sFechaVencimiento} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Número de orden:" value={entConsulta.sOrdenConekta} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Empresa/Cliente" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Folio de empresa/cliente:" value={entConsulta.sFolioEmpresa} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Nombre:" value={entConsulta.sNombreEmpresa} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocInfoField label="Correo electrónico:" value={entConsulta.sCorreoEmpresa} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Producto" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Nombre de producto:" value={entConsulta.sNombreProducto} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Tipo de producto:" value={entConsulta.sTipoProducto} />
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocSubtitulo title="Colaborador" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Nombre:" value={entConsulta.sNombreColaborador} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Correo electrónico:" value={entConsulta.sCorreoColaborador} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Tipo de doctor:" value={entConsulta.sTipoDoctor} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Especialidad:" value={entConsulta.sEspecialidad} />
                    </Grid>
                </Grid>
            )}
        </MeditocModal>
    );
}
